module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"alt_logo":"iOS share icon","download":"Download the app","instructions_1":"To install the application, click on","instructions_2":"and add to the home screen"},"fr":{"alt_logo":"icone de partage iOS","download":"Télécharger l\u0027application","instructions_1":"Pour installer l\u0027application, cliquez sur","instructions_2":"puis ajouter à l\u0027écran d\u0027accueil"}}')
  delete Component.options._Ctor
}
